import React from 'react';
import { Project } from '../types';

const Products: React.FC = () => {
  const products: Project[] = [
    {
      id: 'lingoworld',
      title: 'LingoWorld',
      description: 'This extension of LingoZip provides a comprehensive learning platform for children aiming to pick up additional foreign languages.',
      status: 'In Development',
      category: 'EdTech',
      image: '/screenshots/LingoWorld.png',
      features: ['AI Adaptive Learning', 'Gamified Progression', 'Visual Word Recognition']
    },
    {
      id: 'lingozip',
      title: 'LingoZip',
      description: 'A comprehensive language learning application designed to make mastering new languages accessible and engaging.',
      status: 'In Development',
      category: 'EdTech',
      image: '/screenshots/LingoZip.png',
      features: ['Gamified Progression', 'Visual Word Recognition']
    },
    {
      id: 'edubanking',
      title: 'EduBanking',
      description: 'A project in conjunction with 10x Banking to produce a banking simulation app for children and those who haven\'t used mobile banking applications. The educator dashboard provides teachers with a curriculum and lesson plans, as well as the ability to trigger simulated events (e.g., screen breaking) impacting budgets. Interest payments and payroll are also controlled here.',
      status: 'In Development',
      category: 'FinTech',
      image: '/screenshots/EduBanking.png',
      features: ['Banking Simulation', 'Educator Dashboard', 'Simulated Life Events']
    },
    {
      id: 'primarysuperstars',
      title: 'Primary Superstars',
      description: 'Co-founded between the founder of Simios and his daughter, Primary Superstars consolidates a number of popular school applications into one single place. It reduces complexity for children and cost for schools whilst also improving usability and gamification of learning to improve engagement and test scores.',
      status: 'Beta',
      category: 'EdTech',
      image: '/screenshots/PrimarySuperstars.gif',
      features: ['Unified Platform', 'Gamified Learning', 'Simplified Access']
    },
    {
      id: 'wealthtrack',
      title: 'Family Wealth Tracker',
      description: 'A comprehensive dashboard for families to visualize assets and liabilities in one secure place. (Name TBC)',
      status: 'Concept',
      category: 'FinTech',
      image: 'https://picsum.photos/id/444/600/400',
      features: ['Asset Visualization', 'Liability Tracking', 'Family Access Controls']
    }
  ];

  return (
    <section id="products" className="py-24 bg-simios-light/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            In-House Products
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-simios-muted">
            Building the next generation of educational and financial tools.
          </p>
        </div>

        <div className="space-y-24">
          {products.map((product, index) => (
            <div key={product.id} className={`flex flex-col ${index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 items-center`}>

              {/* Image Preview */}
              <div className="w-full lg:w-1/2 relative group">
                <div className="absolute inset-0 bg-simios-accent rounded-xl rotate-2 group-hover:rotate-1 transition-transform opacity-20"></div>
                <div className="relative rounded-xl overflow-hidden shadow-2xl border border-gray-700 flex justify-center items-center bg-gray-900/50">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-auto h-auto max-h-[400px] max-w-full mx-auto object-contain transform group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute top-4 right-4 bg-simios-dark/90 backdrop-blur px-3 py-1 rounded text-xs font-bold text-white border border-gray-600">
                    {product.status}
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="w-full lg:w-1/2 space-y-6">
                <div className="flex items-center space-x-3">
                  <span className="text-simios-accent text-sm font-bold tracking-wider uppercase">{product.category}</span>
                  <div className="h-px w-10 bg-gray-600"></div>
                </div>

                <h3 className="text-3xl font-bold text-white">{product.title}</h3>
                <p className="text-lg text-simios-muted leading-relaxed">
                  {product.description}
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
                  {product.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center text-gray-300">
                      <div className="w-1.5 h-1.5 bg-simios-accent rounded-full mr-2"></div>
                      {feature}
                    </div>
                  ))}
                </div>

                <div className="pt-6">
                  <button className="text-white border-b border-simios-accent pb-1 hover:text-simios-accent transition-colors">
                    Learn more about {product.title} &rarr;
                  </button>
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;